/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var CSSTransition = require("react-transition-group/CSSTransition");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./DropdownFade.css'); }
exports.DropdownFade = function DropdownFade(_a) {
    var children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    return (React.createElement(CSSTransition, tslib_1.__assign({}, props, { timeout: 150, unmountOnExit: true, mountOnEnter: true, classNames: "dropdownFade" }), children));
};